import React from 'react';
import {
  Container, Row, Col, Tab, Nav,
} from 'react-bootstrap';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { Template } from '../template/index';
import { UsersCreate } from './UsersCreate';
import { UsersList } from './UsersList';

export function Users () {
  const history = useHistory();
  function handleGoBack () {
    history.push('/');
  }
  return (
    <Template>
      <Container className="main-updates">
        <div className="goBack">
          <FontAwesomeIcon icon={faArrowLeft} title="Voltar" size="lg" onClick={handleGoBack} />
          <h2>Gerenciar Usuários</h2>
        </div>
        <hr />
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row>
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">Usuários</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Cadastrar usuário</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <UsersList />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <UsersCreate />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </Template>
  );
}
